import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { getConfig, URLS } from '@constants';

import { EContext, ERefsApps, EResponseStatus, EStore } from '@enums';

import { commonWillUnmount, fetchData } from '@decorators';

import { IAppState } from '@stores';

import { CompilationPage, OuterWrapper } from '@components';

import { ICGIUrlOptions } from '@interfaces/utils';

import { IMatchParams, ICatalogPopularProps, ICatalogPopularState } from './types';

@inject(
	EStore.APPS_POPULAR,
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.COUNTERS,
)
@observer
@commonWillUnmount()
@fetchData([
	async ({ appsPopularStore, currentUserStore }: IAppState, params: IMatchParams) => {
		if (appsPopularStore.status !== EResponseStatus.OK) {
			const limit = getConfig().apps.totalPopular;

			await appsPopularStore.fetch({
				limit,
				context: EContext.MOBILE,
				user: currentUserStore.currentUser,
			});
		}
	},

	// UI STATE
	({ uiStore }: IAppState) => {
		if (uiStore.status !== EResponseStatus.OK) {
			uiStore.setTopMenuInitialState({
				backButtonUrl: getConfig().apps.pathname || URLS.APPS,
			});
		}
	},
])
export class CatalogPopular extends React.Component<ICatalogPopularProps, ICatalogPopularState> {

	componentWillUnmount(): void {
		this.props.appsPopularStore.clearStore();
	}

	fetchApps = async (options: ICGIUrlOptions) =>
		await this.props.appsPopularStore.fetch(options);

	fetchAppsNext = async (options: ICGIUrlOptions) =>
		await this.props.appsPopularStore.fetchNext(options);

	render() {
		const {
			appsPopularStore: store,
		} = this.props;
		const total = getConfig().apps.totalPopular;
		const appsListOptions = {
			apps: store?.data?.apps || [],
			responseStatus: store?.status,
			urlRef: ERefsApps.PAGE_POPULAR,
			hasRating: true,
			hasInstalls: true,
			hasDescription: true,
		};

		return (
			<OuterWrapper>
				<CompilationPage
					appsListOptions={appsListOptions}
					fetchApps={this.fetchApps}
					fetchAppsNext={this.fetchAppsNext}
					compilationDescription={getConfig().apps?.compilationDescription?.popular}
					total={total}
					hasMore={store?.data?.hasMore}
					paginationLimit={total}
				/>
			</OuterWrapper>
		);
	}

}
